import React from 'react';
import { string, shape, object } from 'prop-types';
import useStyles from '../hooks/useStyles';

FormHeading.propTypes = {
	className: string,
	heading: string.isRequired,
	innerCss: shape({
		heading: object,
		subHeading: object
	}),
	subHeading: string
};

FormHeading.defaultProps = {
	innerCss: {}
};

export default function FormHeading({ className, heading, innerCss, subHeading }) {
	const classes = useStyles(styles);
	return (
		<div className={className} css={classes.container}>
			<h1 css={[classes.heading, innerCss.heading]} className="h2">
				{heading}
			</h1>
			{subHeading && <p css={[classes.subHeading, innerCss.subHeading]}>{subHeading}</p>}
		</div>
	);
}

function styles({ css }) {
	return {
		container: css`
			margin-bottom: 16px;
		`,
		heading: css`
			margin-bottom: 8px;
			text-align: center;
		`,
		subHeading: css`
			text-align: center;
		`
	};
}
